<script setup>
import {onMounted, reactive, ref} from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  header: {
    type: Object,
    required: true,
  },
  statuses: {
    type: Object,
    default: [],
  }
})

const numberOfItems = ref(0)
const tooltips = reactive([]);
const baseTooltips = reactive([]);

onMounted(() => {
  const { max } = props.header.options.settings

  numberOfItems.value = [...Array(max).keys()]

  for(let i = 0; i < 5; i++) {
    tooltips[i] = getTooltip(i + 1, true)
    baseTooltips[i] = getTooltip(i + 1, false)
  }
})



const getTooltip = (index, checkStatus) => {
  const tooltip = props.header.options?.tooltip

  if (checkStatus && index === props.item[props.header.value]) {
    if (tooltip) {
      return props.item[tooltip]
    }
  }

  //See RetourStatus.php for statuses and which should correspond to which index
  if (index < 3) {
    return props.statuses[index]
  } else {
    return props.statuses[index + 3]
  }
}
</script>

<template>
  <div class="flex space-x-2">
    <div v-for="index in numberOfItems" :key="index" class="flex items-center">
      <span :title="tooltips[index]"
        v-if="props.header.options.settings.type === 'ball'"
        :class="[
          index < props.item[props.header.value]
            ? (tooltips[index] !== baseTooltips[index] ? 'bg-red-400' : 'bg-green-400')
            : 'bg-gray-100',
          'inline-block h-4 w-4 rounded-full text-gray-800',
        ]"
      ></span>
    </div>
  </div>
</template>
